<template>
  <!-- live preivew -->
  <div id="live-preview" class="lead-form-live-preview-parent" :class="{'lead-form-live-preview-parent-edit-campaign': editing}">
    <div class="relative">
      <h4>{{ $t('Mobile preview') }}</h4>
      <div :class="{'opacity-40': popupAnswers.length > 0}">
        <!-- preview-form-first-screen -->
        <div v-if="screenNum === PAGES.FIRST" :class="[value.form.lang_iso2_code === LANGS.EN ? 'english-form-first-screen' : 'arabic-form-first-screen']">
          <div class="mockup-parent" :class="{'arabic-version-first-screen': value.form.lang_iso2_code === LANGS.AR}">
          <div id="scroll-parent" class="scroll-parent">
            <div class="close-icon-parent">
              <vs-icon class="" icon="speakol-cancel" icon-pack="speakol"></vs-icon>
            </div>

            <div class="section-box headline">
              <h4 class="break-words">{{ value.form.intro.title || previewHeadline }}</h4>
              <p class="break-words">{{ value.form.intro.description || previewDescription }}</p>
            </div>

            <div class="section-box contact-information space-y-6 relative questions-list" :class="[value.form.lang_iso2_code === LANGS.EN ? 'text-left' : 'text-right']">
              <h4>{{ getQuestionLocale('contact_info.title', value.form.lang_iso2_code) }}</h4>

              <div v-if="isPropertyChecked(FULL_NAME_KEY)">
                <label>{{ getQuestionLocale('full_name.title', value.form.lang_iso2_code) }}</label>
                <input type="text" :placeholder="getQuestionLocale('full_name.placeholder', value.form.lang_iso2_code)">
              </div>

              <div v-if="isPropertyChecked(EMAIL_KEY)">
                <label>{{ getQuestionLocale('email.title', value.form.lang_iso2_code) }}</label>
                <input type="text" :placeholder="getQuestionLocale('email.placeholder', value.form.lang_iso2_code)">
              </div>

              <div v-if="isPropertyChecked(WHATSAPP_NUMBER_KEY)">
                <label>{{ getQuestionLocale('whatsapp_number.title', value.form.lang_iso2_code) }}</label>
                <input type="text" :placeholder="getQuestionLocale('whatsapp_number.placeholder', value.form.lang_iso2_code)">
              </div>

              <div v-if="isPropertyChecked(PHONE_NUMBER_KEY)">
                <label>{{ getQuestionLocale('phone_number.title', value.form.lang_iso2_code) }}</label>
                <input type="text" :placeholder="getQuestionLocale('phone_number.placeholder', value.form.lang_iso2_code)">
              </div>

              <div v-if="value.form.properties.custom" class="custom-questions" :dir="value.form.lang_iso2_code === LANGS.EN ? 'ltr': 'rtl'">
                <div v-for="(question) in value.form.properties.custom" :key="question.title" class="mb-6">
                  <label>{{ getQuestionLocale(question.title, value.form.lang_iso2_code) || 'Question' }}</label>
                  <div v-if="question.enum">
                     <div v-if="question.enum.length >= MIN_POPUP_QUESTIONS" class="flex justify-between cursor-pointer">
                      <v-select
                        :options="question.enum.map(answer => {
                          return {
                            label: answer
                          }
                        })"
                        :searchable="false"
                        :clearable="false"
                        class="w-full border-none"
                        :placeholder="$t(`create_campaign.lead_form.preview.select_option_${value.form.lang_iso2_code}`)"
                        :dir="value.form.lang_iso2_code === LANGS.EN ? 'ltr': 'rtl'"
                      >
                        <template v-slot:option="option">
                          <div class="break-words">{{option.label}}</div>
                        </template>
                      </v-select>
                    </div>

                    <div v-else>
                      <custom-questions-preview :answers="question.enum" :lang="value.form.lang_iso2_code"></custom-questions-preview>
                    </div>
                  </div>

                  <span v-else>
                    <input type="text" :placeholder="getQuestionLocale(question.title.replace('.title', '.placeholder'), value.form.lang_iso2_code)">
                  </span>
                </div>
              </div>
            </div>

            <div class="section-box privacy">
              <h4>{{ getQuestionLocale('privacy.title', value.form.lang_iso2_code) }}</h4>

              <p>{{ getQuestionLocale('privacy.description', value.form.lang_iso2_code) }}</p>
            </div>
          </div>

          <div class="form-action">
            <button>{{ getQuestionLocale('cta.title', value.form.lang_iso2_code) }}</button>
          </div>
          </div>
        </div>
        <!-- preview-form-first-screen -->

        <!-- preview-form-second-screen -->
        <div v-else :class="[value.form.lang_iso2_code === LANGS.EN ? 'english-form-first-screen' : 'arabic-form-first-screen text-right']">
          <div class="mockup-parent thank-you-page" :class="{'arabic-version-first-screen text-right': value.form.lang_iso2_code === LANGS.AR}">
            <div class="close-icon-parent">
              <vs-icon class="" icon="speakol-cancel" icon-pack="speakol"></vs-icon>
            </div>

            <div :class="{active : value.form.thank_you.description.length > 70}" class="thank-you-screen-parent">
              <vs-icon icon-pack="speakol" icon="speakol-verified" class=""></vs-icon>
              <h4 class="break-words">{{ value.form.thank_you.title }}</h4>
              <p class="break-words">{{ value.form.thank_you.description }}</p>
            </div>
          </div>
        </div>
        <!-- preview-form-second-screen -->

        <div class="arrows">
          <vs-icon v-bind:class="{ 'disable-arrows': screenNum == 1 }" @click="moveToPage(PAGES.FIRST)" icon-pack="speakol" icon="speakol-arrow-right" class="left-arrow"></vs-icon>
          <h5>{{ screenNum }}/2</h5>
          <vs-icon v-bind:class="{ 'disable-arrows': screenNum == 2 }" @click="moveToPage(PAGES.SECOND)" icon-pack="speakol" icon="speakol-arrow-right"></vs-icon>
        </div>
      </div>
    </div>
  </div>
  <!-- live preivew -->
</template>

<script>
import CustomQuestionsPreview from './custom-preview.vue'
import { LeadFormMixin } from '@/mixins/LeadFormMixin.js'

export default {
  mixins: [LeadFormMixin],
  props: {
    value: {
      required: true,
      type: Object
    },
    editing: {
      required: true,
      type: Boolean
    },
    screenNum: {
      required: true,
      type: Number
    }
  },
  components: {
    CustomQuestionsPreview
  },

  data () {
    return {
      FULL_NAME_KEY: 'full_name',
      EMAIL_KEY: 'email',
      NUMBER_KEY: 'number',
      PHONE_NUMBER_KEY: 'phone_number',
      WHATSAPP_NUMBER_KEY: 'whatsapp_number',
      DEFAULT_QUESTIONS: ['full_name', 'email'],
      PRIMITIVE_QUESTIONS: ['full_name', 'email', 'number', 'phone_number', 'whatsapp_number'],
      LANGS: {
        EN: 'en',
        AR: 'ar'
      },
      PAGES: {
        FIRST: 1,
        SECOND: 2
      },
      previewHeadline: 'Headline',
      previewDescription: 'Description',
      popupAnswers: []
    }
  },

  watch: {
    'value.form.lang_iso2_code' () {
      this.value.form.thank_you.title = this.$t(`create_campaign.lead_form.creation.thank_you_title_default_${this.value.form.lang_iso2_code}`)
      this.value.form.thank_you.description = this.$t(`create_campaign.lead_form.creation.thank_you_desc_default_${this.value.form.lang_iso2_code}`)

      this.previewHeadline = this.$t(`create_campaign.lead_form.preview.headline_${this.value.form.lang_iso2_code}`)
      this.previewDescription = this.$t(`create_campaign.lead_form.preview.description_${this.value.form.lang_iso2_code}`)
    }
  },

  methods: {
    scrollToBottom () {
      const questionsScroll = document.getElementById('scroll-parent')

      questionsScroll.scrollTop = questionsScroll.scrollHeight - document.querySelector('.privacy').clientHeight - 350
    },

    moveToPage (pageNumber) {
      this.$parent.$parent.moveToPage(pageNumber)
    },

    isPropertyChecked (propertyName) {
      return propertyName in this.value.form.properties.primitive
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .vs-input--label {
  padding-left: 0 !important;
}

.custom-questions {
  /deep/ .v-select {
    width: 100%;

    .vs__dropdown-toggle {
      border: none;
      border-bottom: 1px solid #c2c2c2;
    }
  }
}

.lead-form-live-preview-parent-edit-campaign {
  position: unset !important;
  height: auto !important;
}

.lead-form-live-preview-parent {
  position: sticky;
  top: 70px;
  height: 70vh;

  h4 {
    color: #000;
    font-weight: 500;
    margin-bottom: 24px;
  }

  .thank-you-page {
    height: 420px;
    max-height: 420px;
    overflow-y: auto;
    padding: 16px 8px 8px 7px !important;
  }

  .english-form-first-screen {
    .close-icon-parent {
      margin-right: 8px;
    }
  }

  .arabic-version-first-screen,
  .arabic-version-second-screen {
    h4,
    p,
    input,
    label,
    .label-parent {
      text-align: right;
    }

    .close-icon-parent {
      text-align: left !important;
    }
  }

  .mockup-parent {
    background: #fafafa;
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.24);
    border-radius: 8px;
    padding: 16px 0 8px 7px;

    label {
      color: #797a7b;
      font-weight: 500;
      font-size: 14px;
    }

    input {
      border: none;
      border-bottom: 1px solid #c2c2c2;
      outline: none;
      box-shadow: none;
      display: block;
      margin-top: 8px;
      padding-bottom: 6px;
      width: 100%;
    }

    input::placeholder {
      color: #c2c2c2;
      font-size: 14px;
    }

    .scroll-parent {
      height: 360px;
      max-height: 360px;
      overflow-y: auto;
      overflow-x: hidden;
      position: relative;
    }

    .close-icon-parent {
      margin-bottom: 24px;
      text-align: right;

      i {
        opacity: 0.5;
        background: #323232;
        color: white;
        font-size: 13px !important;
        border-radius: 100%;
        padding: 5.5px;
      }
    }

    .privacy {
      line-height: 24px;
    }

    .section-box {
      background-color: white;
      box-shadow: 0 0 2px rgba(0, 0, 0, 0.24);
      border-radius: 4px;
      margin-bottom: 16px;
      padding: 16px;
      margin-left: 1px;
      margin-right: 8px;

      h4 {
        color: #323232;
        font-size: 16px;
        font-weight: 500;
        margin-bottom: 6px;
      }

      p {
        color: #797a7b;
        font-size: 14px;
        font-weight: normal;
      }
    }

    .contact-information {
      h4 {
        margin-bottom: 24px;
      }
    }

    .form-action {
      button {
        width: 97.2%;
        background: #0092d7;
        border-radius: 4px;
        color: white;
        height: 36px;
        font-size: 14px;
        border: none;
        outline: none;
        font-weight: normal;
      }
    }

    .thank-you-screen-parent {
      background: #fff;
      box-shadow: 0 0 2px rgba(0, 0, 0, 0.24);
      border-radius: 4px;
      text-align: center;
      padding: 48px 8px;
      margin-top: 80px;

      i {
        color: #21ba45;
        font-size: 40px !important;
      }

      h4 {
        color: #323232;
        font-weight: bold;
        font-size: 16px;
        margin-bottom: 6px;
        margin-top: 24px;
        text-align: center;
      }

      p {
        color: #797a7b;
        font-weight: 300;
        font-size: 14px;
        text-align: center;
      }
    }
  }

  .arrows {
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 32px;

    .disable-arrows {
      color: #c2c2c2 !important;
      cursor: not-allowed !important;
    }

    .left-arrow {
      transform: rotate(180deg);
    }

    i {
      font-size: 12px !important;
      font-weight: 900;
      cursor: pointer;
      color: #323232;
    }

    h5 {
      color: #323232;
      font-size: 14px;
      font-weight: 300px;
      margin-left: 16px;
      margin-right: 16px;
    }
  }

  /deep/ .vs__dropdown-option {
    white-space: break-spaces;;
  }
}

@media (max-width: 768px) {
  .lead-form-live-preview-parent {
    position: unset;
    top: 0;
    height: auto;
  }
}

.scroll-parent::-webkit-scrollbar {
  width: 7px;
}

.scroll-parent::-webkit-scrollbar-track {
  border-radius: 4px;
}

.scroll-parent::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background: gray;
}

.thank-you-page::-webkit-scrollbar {
  width: 7px;
}

.thank-you-page::-webkit-scrollbar-track {
  border-radius: 4px;
}

.thank-you-page::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background: gray;
}

textarea::-webkit-scrollbar {
  width: 7px;
}

textarea::-webkit-scrollbar-track {
  border-radius: 4px;
}

textarea::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background: gray;
}

.active {
  margin-bottom: 118px !important;
}
</style>
